import React, { useState, useRef } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import TextBlock from "components/Shared/TextBlock";
import {
  verifyMultiFactorMethodsForUser,
} from "requests/profile";
import MDialog, { ACTION_CLOSE } from "components/Shared/MDialog.tsx";

const VerifyTwoFactorSetup = (props) => {
  const mounted = useRef(true);
  // Two Factor Code to verify setup
  const [twoFactorCode, setTwoFactorCode] = useState();
  // Response from Verification step
  const [twoFactorVerifyResponse, setTwoFactorVerifyResponse] = useState({ data: null, isFetching: false });
  // User Response Message
  const [responseMessage, setResponseMessage] = useState({ message: "", showDialog: false });

  const {
    init,
    profile,
    history,
    wrapUpAction,
    clearTwoFactorResponse,
    data,
  } = props;

  let editInitiated = false;
  let multiFactorMethod = "";
  let informationMessage = "";
  let requiresVerification = "";

  if (data) {
    editInitiated = data.editInitiated;
    multiFactorMethod = data.multiFactorMethod;
    informationMessage = data.informationMessage;
    requiresVerification = data.requiresVerification;
  }

  let submitMultiFactorVerify = () => {
    setTwoFactorVerifyResponse({ data: null, isFetching: true });
    verifyMultiFactorMethodsForUser(profile.internetUserId, {
      multiFactorMethod: multiFactorMethod,
      verificationCode: twoFactorCode,
    }, (s) => {
      setTwoFactorVerifyResponse({ data: s, isFetching: false });
      setResponseMessage({ message: GetVerifyResponseMessage(s), showDialog: true });
    }, () => {
      setTwoFactorVerifyResponse({ data: {}, isFetching: false });
      setResponseMessage({ message: GetVerifyResponseMessage({ editSuccessful: false }), showDialog: true });
    }, mounted);
  };

  let GetVerifyResponseMessage = (resp) => {
    return resp && resp.editSuccessful
      ? `Success! You've added a Two-Factor Verification Method. 
         Two-Factor Methods can be managed in your profile settings.`
      : "There was an issue with the verification code you sent. Please try again.";
  };

  let verifyResultOnClose = () => {
    setResponseMessage({ message: "", showDialog: false });
    setTwoFactorVerifyResponse({ data: null, isFetching: false });
  };

  let verifyResultActions = () => {
    let actions = [];
    if (twoFactorVerifyResponse.data && !twoFactorVerifyResponse.data.editSuccessful)
      actions.push({ code: ACTION_CLOSE, onClick: () => verifyResultOnClose(), helpText: "Go Back" });
    return actions;
  };

  let verifyActions = () => {
    let actions = [];
    actions.push({ code: ACTION_CLOSE, onClick: () => clearTwoFactorResponse(), helpText: "Cancel" });
    return actions;
  };

  return (
    <>
      <MDialog
        id={"dialog-verify-results"}
        visible={responseMessage.showDialog}
        actions={verifyResultActions()}
        title={"Verification Result"}
        width={500}>
        <TextBlock field={responseMessage.message} />
        {twoFactorVerifyResponse.data && twoFactorVerifyResponse.data.editSuccessful &&
          <>
            <hr />
            <div className="verify-controls" style={{ gap: '10px' }}>
              {init &&
                <Button onClick={() => history.push("../profile")}>
                  Go to My Profile
                </Button>}
              <Button onClick={() => wrapUpAction()}>
                Continue
              </Button>
            </div>
          </>
        }
      </MDialog>

      <MDialog
        id={"dialog-verify"}
        visible={!twoFactorVerifyResponse.data}
        actions={verifyActions()}
        title={"Please Enter Verification Code"}
        width={500}>
        <>
          <TextBlock field={`${informationMessage}`} />
          {requiresVerification &&
            <>
              <TextField
                variant="standard"
                id="verification-code"
                label={"Verification Code"}
                value={twoFactorCode}
                onChange={e => setTwoFactorCode(e.target.value)}
                required
              />
              <div className="verify-controls" style={{ marginTop: '20px' }}>
                <Button disabled={!editInitiated || twoFactorVerifyResponse.isFetching || !twoFactorCode}
                 
                  onClick={() => submitMultiFactorVerify()}>
                  Continue
                </Button>
              </div>
            </>
          }
        </>
      </MDialog>
    </>
  );
};

VerifyTwoFactorSetup.propTypes = {
  init: PropTypes.bool,
  profile: PropTypes.object,
  history: PropTypes.object,
  wrapUpAction: PropTypes.func,
  clearTwoFactorResponse: PropTypes.func,
  multiFactorMethods: PropTypes.object,
  refreshMultiFactorMethods: PropTypes.func,
  data: PropTypes.object,
};

const mstp = state => ({
  profile: state.user.profile,
});

export default connect(mstp)(VerifyTwoFactorSetup);